/**
 * @file lottie right star 动画
 */

import {Component} from 'san';
import lottie from 'lottie-web';
import {rightStar} from '../../../../common/lottie-data/right-star-lottie';

export default class App extends Component {
    static template = /*html*/`
        <fragment>
            <div s-ref="lottie-right" class="right-star"></div>
        </fragment>
    `;

    attached(): void {
        const container = this.ref('lottie-right') as unknown as HTMLDivElement;

        lottie.loadAnimation({
            container,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: rightStar,
        });
    }
}